<!--
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2018-12-21 17:02:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-03 00:47:37
 -->
<template>
  <div id="app" style="background:#fff;" class="local_scroll">
    <!-- <view-box ref="viewBox"> -->
    <!-- PS 暂时先给注释掉，这一版不需要header -->
    <!-- <home-header :wx-user-info="wxUserInfo" :title="headerName" :ifFix="headerName=='直播详情'?true:false" v-show="headerName != '搜索' && headerName !='noHeader'"></home-header> -->
    <home-header
      v-if="
        !wxUserInfo.userDataStatus &&
          /Share|headlineDetail/.test($route.fullPath)
      "
      :wx-user-info="wxUserInfo"
      :title="headerName"
      :ifFix="headerName == '直播详情' ? true : false"
      v-show="
        headerName != '搜索' &&
          headerName != 'noHeader' &&
          !/livingShareCard/.test($route.fullPath)
      "
    ></home-header>
    <!--:enter-active-class="animateClass"-->
    <!-- <transition> -->
    <!--<transition :name="'vux-pop-' + direction">-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- </transition> -->
    <loading v-model="change"></loading>
    <!-- </view-box> -->
    <!-- <loading-cover :cover-type="coverType"></loading-cover> -->
  </div>
</template>
<script>
import { Loading, cookie, querystring, dateFormat, ViewBox } from 'vux';
import { mapState, mapActions } from 'vuex';
import LoadingCover from '@/components/loadingCover.vue';
import HomeHeader from '@/components/Header.vue';
export default {
  name: 'app',
  data() {
    return {
      ttt: 0,
      goBackList: [],
      animateClass: 'bounceInLeft',
      direction: 'in',
      coverType: 1, // loading类型 1 首页 2 专区
      routeToUrl: ''
    };
  },
  components: {
    Loading,
    ViewBox,
    LoadingCover,
    HomeHeader
  },
  computed: {
    ...mapState({
      change: state => state.change,
      headerName: state => state.headerName,
      wxUserInfo: state => state.wxUserInfo,
      loadingCover: state => state.loadingCover
    })
  },
  methods: {
    ...mapActions(['classify', 'flowerCount', 'loadingCoverAction'])
  },
  watch: {
    wxUserInfo(val) {},
    $route(to, from) {
      this.routeToUrl = to.fullPath;
      console.log(this.routeToUrl);
      console.log(
        !this.wxUserInfo.userDataStatus && /Share/.test(this.routeToUrl)
      );
      this.classify({
        // 重置类别
        categoryName: '',
        id: ''
      });
      this.flowerCount(0); // 重置鲜花
      if (to.name == 'home') {
        this.goBackList = [];
        this.direction = 'out';
      } else if (this.goBackList.indexOf(to.name) == -1) {
        this.goBackList.push(to.name);
        this.direction = 'in';
      } else {
        if (
          this.goBackList.indexOf(to.name) > this.goBackList.indexOf(from.name)
        ) {
          this.direction = 'in';
        } else {
          this.direction = 'out';
        }
      }
    }
  },
  mounted() {
    //        console.log(dateFormat(new Date(1513344600000),'YYYY-MM-DD HH:mm:ss'))
  },
  created() {
    //   // app中route.name 有问题
    if (/\/home|\/zoneList/.test(location.href)) {
      if (/\/home/.test(location.href)) {
        this.loadingCoverAction(1);
      } else if (/\/zoneList/.test(location.href)) {
        this.loadingCoverAction(2);
      }
    }

    //   console.log([
    //     "                   _ooOoo_",
    //     "                  o8888888o",
    //     "                  88\" . \"88",
    //     "                  (| -_- |)",
    //     "                  O\\  =  /O",
    //     "               ____/`---'\\____",
    //     "             .'  \\\\|     |//  `.",
    //     "            /  \\\\|||  :  |||//  \\",
    //     "           /  _||||| -:- |||||-  \\",
    //     "           |   | \\\\\\  -  /// |   |",
    //     "           | \\_|  ''\\---/''  |   |",
    //     "           \\  .-\\__  `-`  ___/-. /",
    //     "         ___`. .'  /--.--\\  `. . __",
    //     "      .\"\" '<  `.___\\_<|>_/___.'  >'\"\".",
    //     "     | | :  `- \\`.;`\\ _ /`;.`/ - ` : | |",
    //     "     \\  \\ `-.   \\_ __\\ /__ _/   .-` /  /",
    //     "======`-.____`-.___\\_____/___.-`____.-'======",
    //     "                   `=---='",
    //     "^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^",
    //     "              佛祖加持       永无BUG"
    //   ].join('\n'));
  }
};
</script>

<style lang="less">
@import '~vux/src/styles/1px.less';
body {
  height: 100%;
  width: 100%;
  background: #fff;
}
#app {
  max-width: 10rem;
  min-height: 100%;
  position: relative;
  margin: 0 auto;
  .vux-1px-b:after {
    border-bottom-color: #e5e5e5;
  }
}
// .weui-tab{
//   position: absolute !important;
// }
.hasPadding {
  padding: 0 0.4rem;
}

.padding_top_bottom {
  padding: 0.2rem /* 15/75 */ 0;
}
.colorRed {
  //关键字高亮
  color: red;
}
.weui-tab__panel {
  width: 100%;
  position: absolute;
  height: auto !important;
  left: 0;
  top: 0;
  padding-bottom: 0 !important;
}
</style>

<style scoped>
.vux-pop-out-enter-active,
.vux-pop-out-leave-active,
.vux-pop-in-enter-active,
.vux-pop-in-leave-active {
  will-change: transform;
  transition: all 500ms;
  height: 100%;
  /*top: 0;*/
  position: absolute;
  backface-visibility: hidden;
  perspective: 1000;
}

.vux-pop-out-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.vux-pop-out-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.vux-pop-in-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.vux-pop-in-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
</style>
